import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useAppSelector } from '../../hooks';
import { CarouselType } from '../../types/types';
import { IMG_BASE_URL } from '../../utils/config';
import { motion } from "framer-motion";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const AboutCarousel: React.FC = ()=>{

    const theme = useTheme();
    const [ carousels,setCarousels ] = React.useState<CarouselType[]>([])
    const { data } = useAppSelector(state=> state.frontViewData)
    const [activeStep, setActiveStep] = React.useState<number>(0);
    const [ maxSteps,setMaxSteps ] = React.useState<number>(0)

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    React.useEffect(()=>{
        if(data && data.data){
            const fetchedData = data.data;
            const carousels = fetchedData.carousels
            setCarousels(carousels)
            setMaxSteps(carousels.length)
        }
    },[data])

    return (
        <motion.div
            className="box"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, delay: 0.5 }}
        >
        <Box sx={{ width: { xs: 350, sm: 500, md: 600, lg: 700, xl: 900 }, flexGrow: 1, mx: 'auto', mt: 5 }}>
            <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                {
                    carousels.length > 0 ?
                    carousels.map((carousel, index) => (
                    <div key={index}>
                        {Math.abs(activeStep - index) <= 2 ? (
                        <Box
                            component="img"
                            sx={{
                            //   height: 255,
                            display: 'block',
                            //   maxWidth: 400,
                            overflow: 'hidden',
                            width: '100%',
                            }}
                            src={`${IMG_BASE_URL}${carousel.link}`}
                            alt={"loading..."}
                        />
                        ) : null}
                    </div>
                ))
                :
                <></>
            }
            </AutoPlaySwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                >
                    Next
                    {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft />
                    ) : (
                    <KeyboardArrowRight />
                    )}
                </Button>
                }
                backButton={
                <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight />
                    ) : (
                    <KeyboardArrowLeft />
                    )}
                    Back
                </Button>
                }
            />
        </Box>
        </motion.div>
    );
}

export default AboutCarousel;
